import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_TONGQUATCUAHANG } from "actions/TongQuatCuaHang/actionTypes";
import {
  getListTongQuatCuaHangSuccess,
  getListTongQuatCuaHangFailure,
} from "actions/TongQuatCuaHang";
import TongQuatCuaHangApi from "service/danhSachKhachHangApi";
import { pushNotification } from "utils/notifications";

function* getListTongQuatCuaHang(action) {
  try {
    const response = yield call(TongQuatCuaHangApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListTongQuatCuaHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListTongQuatCuaHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListTongQuatCuaHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_TONGQUATCUAHANG, getListTongQuatCuaHang);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
